import type { ReactNode } from 'react'
import { Card } from '@/React/Shared/Component/Card'

export interface SimpleStatCardProps {
    title: ReactNode
    value: ReactNode
    className?: string
}

export function SimpleStatCard({
    title,
    value,
    className = '',
}: SimpleStatCardProps) {
    return (
        <Card.Container className={className}>
            <Card.Content>
                <div className="text-xs font-semibold uppercase text-gray-600">
                    {title}
                </div>
                <div className="flex items-center justify-start gap-2 mt-1">
                    <div className="text-2xl font-bold">{value}</div>
                </div>
            </Card.Content>
        </Card.Container>
    )
}
